import styled, { css } from "styled-components";
import { StickyHeader } from "./Header";

const UnnamedComponent = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1140px;
  padding-left: 15px;
  padding-right: 15px;

  ${StickyHeader} + & {
    min-height: calc(100vh - 130px);
  }

  ${(props) =>
    props.$paddingY &&
    css`
      padding-top: 50px;
      padding-bottom: 50px;
    `};

  ${(props) =>
    props.$borderTop &&
    css`
      border-top: 1px solid white;
    `};
`;

export const SectionTitle = styled.h1``;

export const SectionSeparator = styled.div`
  background: linear-gradient(to right, #bababa, #a86d00, #515151) border-box;
  height: 1.5px;
`;

export default UnnamedComponent;
